// removed by extract-text-webpack-plugin
module.exports = {"pinging":"_2xVHWDJ0fWuVRKKnDBPnca","wiggling":"_2cWbEDXpbpV1y1r2208Gbk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ChannelListItemActions/style.css
 ** module id = 587
 ** module chunks = 0
 **/